import axios, { AxiosRequestConfig } from 'axios'
import type { ParsedContent } from '@/interfaces'

export class NestApi {
  static async getRemoteContent(contentURL: string): Promise<ParsedContent> {
    const apiResult = await this.makeRequest<ParsedContent>({
      method: 'post',
      url: '/scraper/page',
      data: {
        url: contentURL,
      },
    })

    return apiResult
  }

  static async setRemoteContent(contentURL: string, html: string, scripts: string): Promise<ParsedContent> {
    const apiResult = await this.makeRequest<ParsedContent>({
      method: 'post',
      url: '/scraper/pagecleaned',
      data: {
        url: contentURL,
        html: html,
        scripts: scripts,
      },
    })

    return apiResult
  }

  private static async makeRequest<T>(config: AxiosRequestConfig): Promise<T> {
    axios.defaults.baseURL = this.getBaseUrl()
    axios.defaults.headers.common.Authorization = `Bearer ${this.getBearerToken()}`
    const response = await axios(config).then(function (response) {
      return response.data as T
    }).catch(function (error) {
      if ('data' in error.response) {
        let message = JSON.stringify(error.response)
        if ('errors' in error.response.data) {
          message = JSON.stringify(error.response.data.errors)
        }
        if ('message' in error.response.data) {
          message = error.response.data.message
        }
        throw new Error(`${error.response.data.code}: ${message}`)
      } else {
        throw new Error(error)
      }
    })
    return response as T
  }

  private static getBaseUrl(): string {
    return process.env.VUE_APP_NESTAPI_BASE_URL
  }

  private static getBearerToken(): string {
    return process.env.VUE_APP_NESTAPI_TOKEN
  }
}
